// eslint-disable-next-line import/no-anonymous-default-export
export var survey_queue = []
export var polling_obj = {
    is_polling: false,
    poling_index: 23
}
